export default __webpack_public_path__ + "static/media/footer_whitepaper.ad4876ba.svg";